export default {
  "api": process.env.API,
  "realApi": process.env.API,
  "localApi": process.env.API,
  "domain": process.env.DOMAIN,
  "domainWithPort": process.env.DOMAIN,
  "apiWS": process.env.API_WS
}